import {
	Box,
	CircularProgress,
	CircularProgressProps,
	Theme,
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { percent } from 'csx'

export const FullscreenSpinner = (props: CircularProgressProps) => {
	const styles = useStyles()

	return (
		<Box className={styles.fullScreenSpinnerRoot}>
			<CircularProgress {...props} />
		</Box>
	)
}

const useStyles = makeStyles((theme: Theme) => ({
	fullScreenSpinnerRoot: {
		display: 'flex',
		backgroundColor: theme.palette.background.paper,

		justifyContent: 'center',
		alignItems: 'center',

		height: percent(100),
		width: percent(100),
	},
}))
